// FETCH
export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAIL = "FETCH_USER_FAIL";

export function fetchUser() {
  return {
    type: FETCH_USER,
    payload: {
      request: {
        url: "/user.json",
      },
    },
  };
}

// UPDATE
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export function updateUser(data) {
  return {
    type: UPDATE_USER,
    data,
    payload: {
      request: {
        method: "PUT",
        url: "/user.json",
        data,
      },
    },
  };
}

// UPDATE_USER_LOCAL
export const UPDATE_USER_LOCAL = "UPDATE_USER_LOCAL";

export function updateUserLocal(data) {
  return {
    type: UPDATE_USER_LOCAL,
    data,
  };
}

// LOGIN
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";

export function loginUser(email, password) {
  return {
    type: LOGIN_USER,
    payload: {
      request: {
        method: "POST",
        url: "/login.json",
        data: {
          email,
          password,
        },
      },
    },
  };
}

// LOGOUT
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_FAIL = "LOGOUT_USER_FAIL";

export function logoutUser() {
  return {
    type: LOGOUT_USER,
    payload: {
      request: {
        method: "POST",
        url: "/logout.json",
      },
    },
  };
}

// CHANGE PASSWORD
export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS";
export const CHANGE_USER_PASSWORD_FAIL = "CHANGE_USER_PASSWORD_FAIL";

export function changeUserPassword(password, newPassword, newPasswordConfirm) {
  return {
    type: CHANGE_USER_PASSWORD,
    payload: {
      request: {
        method: "POST",
        url: "/change-password.json",
        data: {
          password: password,
          new_password: newPassword,
          new_password_confirm: newPasswordConfirm,
        },
      },
    },
  };
}

// RESET PASSWORD
export const RESET_USER_PASSWORD = "RESET_USER_PASSWORD";
export const RESET_USER_PASSWORD_SUCCESS = "RESET_USER_PASSWORD_SUCCESS";
export const RESET_USER_PASSWORD_FAIL = "RESET_USER_PASSWORD_FAIL";

export function resetUserPassword(email) {
  return {
    type: RESET_USER_PASSWORD,
    payload: {
      request: {
        method: "POST",
        url: "/reset-password.json",
        data: {
          email,
        },
      },
    },
  };
}

// REGISTER
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

export function registerUser(email, password, passwordConfirm) {
  return {
    type: REGISTER_USER,
    payload: {
      request: {
        method: "POST",
        url: "/register.json",
        data: {
          email,
          password,
          password_confirm: passwordConfirm,
        },
      },
    },
  };
}

// UNSUBSCRIBE
export const UNSUBSCRIBE_USER = "UNSUBSCRIBE_USER";
export const UNSUBSCRIBE_USER_SUCCESS = "UNSUBSCRIBE_USER_SUCCESS";
export const UNSUBSCRIBE_USER_FAIL = "UNSUBSCRIBE_USER_FAIL";

export function unsubscribeUser(key) {
  return {
    type: UNSUBSCRIBE_USER,
    payload: {
      request: {
        method: "POST",
        url: "/unsubscribe.json",
        data: {
          key,
        },
      },
    },
  };
}

// CLEAR CACHE
export const CLEAR_CACHE = "CLEAR_CACHE";
export const CLEAR_CACHE_SUCCESS = "CLEAR_CACHE_SUCCESS";
export const CLEAR_CACHE_FAIL = "CLEAR_CACHE_FAIL";

export function clearCache() {
  return {
    type: CLEAR_CACHE,
    payload: {
      request: {
        url: "/user.json",
      },
    },
  };
}
